
import { Button } from '@/components/ui/button';

interface CTASectionProps {
  onOpenContact: () => void;
}

const CTASection = ({ onOpenContact }: CTASectionProps) => {
  return (
    <div className="relative py-20 bg-gradient-to-br from-primary/10 via-primary-glow/5 to-background overflow-hidden">
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-1/4 left-1/4 w-1/3 h-1/3 bg-gradient-radial from-primary/15 to-transparent rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-1/4 h-1/4 bg-gradient-radial from-primary-glow/10 to-transparent rounded-full blur-2xl"></div>
      </div>
      <div className="relative container mx-auto px-4 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-6">
            Ready to Make Aging Strategy Part of Your Practice?
          </h2>
          <p className="text-lg text-muted-foreground mb-10">
            Join advisors who are embedding aging-at-home strategy into long-term client relationships.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              className="px-8 py-6 text-lg shadow-floating hover:shadow-glow transition-all duration-300 hover:-translate-y-1"
              onClick={onOpenContact}
            >
              Become a SeniorThrive Advisor Partner
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="px-8 py-6 text-lg border-2 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 hover:-translate-y-1"
              onClick={onOpenContact}
            >
              Book a Strategy Session
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTASection;
